import "@/theme/initTheme";
import React from "react";
import ReactDOM from "react-dom/client";
import { KwMotionProvider } from "@minegocio/shared/ui/motion";
import "./index.css";
import "@/styles/theme.css";
import "leaflet/dist/leaflet.css";
import "./lib/leafletIcons"; // 👈 aquí
import Providers from "./app/providers";
import AppRouter from "./routes/AppRouter";

// La carga arranca ya, en paralelo con el render: los m.* que entran desde
// opacity 0 (carrusel, AuthShell) no esperan a que se pida el chunk.
const motionFeatures = import("./lib/motion-features").then((m) => m.default);
const loadMotionFeatures = () => motionFeatures;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* Un solo proveedor de motion (KwMotionProvider: LazyMotion estricto +
        MotionConfig reducedMotion="user"), con las features en un chunk
        asíncrono para no sumarle ~29 kB gzip a la entrada. */}
    <KwMotionProvider features={loadMotionFeatures}>
      <Providers>
        <AppRouter />
      </Providers>
    </KwMotionProvider>
  </React.StrictMode>
);
